<template>
  <div>
    <BreadCrumb
      class="bread"
      :breads="['商品管理', '商品分组列表']"
    ></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">商品分组列表</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="分组名称">
            <el-input v-model="search.name" maxlength="30"></el-input>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="searchForm"
              >查询</el-button
            >
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- <div class="operate-con">
      <el-button size="small" @click="openAdd">新增</el-button>
    </div> -->
    <div class="table-con">
      <el-table :data="tableList" stripe v-loading="loading">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          :index="indexMethod"
        ></el-table-column>
        <el-table-column
          label="分组名称"
          align="center"
          prop="name"
        ></el-table-column>
        <el-table-column
          label="商品数量"
          align="center"
          prop="goods_count"
        ></el-table-column>
        <el-table-column
          label="算法服务器"
          align="center"
          prop="type"
        ></el-table-column>
        <el-table-column label="关联商品库" align="center">
          <div slot-scope="scope">
            <div>{{ scope.row.correlation.name }}</div>
            <div>
              <el-button v-if="scope.row.correlation.name" type="primary" size="small" @click="emptyCorrelation(scope.row)">清空</el-button>
            </div>
          </div>
        </el-table-column>
        <el-table-column
          label="被关联商品库"
          align="center"
          prop="correlationed"
        >
          <div slot-scope="scope">
            <template v-for="(item, index) in scope.row.correlationed">
              <div :key="index" v-if="scope.row.correlationed != ''">
                <p>{{ item.name }}</p>
              </div>
            </template>
          </div>
        </el-table-column>
        <el-table-column label="下级使用" v-if="getShow()">
          <template slot-scope="scope">
            <el-switch
              @change="switchOpen(scope)"
              v-model="scope.row.lower_use"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="shared" label="共享">
          <template slot-scope="scope">
            <el-switch
              @change="switchShared(scope.row)"
              v-model="scope.row.shared"
            ></el-switch>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="训练次数" align="center" prop="training_times"></el-table-column>
        <el-table-column label="最后一次训练时间" align="center" prop="latest_training"></el-table-column> -->
        <el-table-column label="操作" align="center" width="400px">
          <div slot-scope="scope">
            <!-- <el-button size="small" @click="openTrainDetail(scope.row.id)">训练详情</el-button> -->
            <!-- <el-button
              size="small"
              type="primary"
              @click="copyGoods(scope.row.id)"
              v-if="scope.row.shared === true"
              >复制</el-button
            > -->
            <!-- <el-button
              size="small"
              type="primary"
              @click="copyGoods(scope.row.id)"
              >复制</el-button
            > -->
            <el-button
              size="small"
              type="primary"
              @click="associationGoods(scope.row.id)"
              >关联</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="openView(scope.row.id)"
              >查看</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="openUpdate(scope.row.id)"
              v-if="!scope.row.correlation.name"
              >修改</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="deleteItem(scope.row.id)"
              v-if="!scope.row.correlation.name"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationWrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNum"
        :layout="pageLayout"
        :total="total"
      >
      </el-pagination>
    </div>
    <simple-find-dialog
      :show="dialogVisible"
      @close="closeSimpleDialog"
      :dialogData="dialogData"
      :width="'500px'"
    ></simple-find-dialog>
    <!-- 弹框 -->
    <!-- <el-dialog title="共享商品库选择" :visible.sync="goodsDialog" width="400px">
      <el-form size="small" label-width="100px">
        <el-form-item label="共享商品库">
          <el-input
            style="width: 200px"
            suffix-icon="el-icon-search"
            readonly
            v-model="copyData.name"
            @focus="setDialogSearchItem('copy')"
          ></el-input>
        </el-form-item>
        <span style="font-size: 80%; color: red"
          >注意：确认后，此商品库将完全复制共享商品库的数据</span
        >
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="copyBtn">确认</el-button>
      </div>
    </el-dialog> -->
    <!-- 弹框关联 -->
    <el-dialog
      title="关联商品库选择"
      :visible.sync="associationGoodsDialog"
      width="400px"
    >
      <el-form size="small" label-width="100px">
        <el-form-item label="关联商品库">
          <el-input
            style="width: 200px"
            suffix-icon="el-icon-search"
            readonly
            v-model="associationData.name"
            @focus="setDialogSearchItem('association')"
          ></el-input>
        </el-form-item>
        <span style="font-size: 80%; color: red"
          >注意：关联后，此商品库将跟随关联的商品库进行变化，比如新增或者删除商品</span
        >
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="associationBtn">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import listMixin from "@/mixins/list";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import SimpleFindDialog from "@/components/SimpleFindDialog";
export default {
  components: {
    BreadCrumb,
    SimpleFindDialog,
  },
  mixins: [listMixin],
  data() {
    return {
      correlationShow:null,
      // goodsDialog: false,
      associationGoodsDialog: false,
      dialogVisible: false,
      dialogData: {},
      // copyId:"",
      associationId: "",
      // copyData: {},
      // copyDataId: "",
      associationData: {},
      associationDataId: "",
      search: {
        exp: "", // 保质期
        is_open: "", //开关
        name: "",
        goods_count: "",
        type: "",
        lower_use: "",
      },
      // isShowClose:true,
    };
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
    // this.isShowClose()
  },
  methods: {
    getShow() {
      let type = false;
      type =
        JSON.parse(localStorage.getItem("pc_permission")) &&
        JSON.parse(localStorage.getItem("pc_permission")).length > 0;
      return type;
    },
    getData() {
      this.getTableData(apis.goods_group, "get", this.search)
        .then((res) => {
          // console.log(res);
        })
        .catch(() => {});
    },
    // // 判断登录显示下级使用
    // isShowClose() {
    //   this.$axios.post(apis.logins).then(res => {
    //     console.log('开关显示',res);
    //   })

    // },
    // 查询
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    reset() {
      this.search = {};
      this.searchForm();
    },
    // 开关
    switchOpen(scope) {
      this.$axios.get(apis.group_lower + "/" + scope.row.id).then((res) => {
        if (res.data.code === 200) {
          if (scope.row.lower_use == 1) {
            this.$message({
              message: "开启成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "关闭成功",
              type: "success",
            });
          }
        }
      });
    },
    // 共享
    switchShared(row) {
      this.$axios.get(apis.ch_goods_group + "/" + row.id).then((res) => {
        if (res.data.msg === "开启成功") {
          this.$message({
            message: "开启成功",
            type: "success",
          });
        } else if (res.data.msg === "关闭成功") {
          this.$message({
            message: "关闭成功",
            type: "success",
          });
        }
      });
    },
    // 新增
    // openAdd() {
    //   this.$router.push({
    //     name: 'goodsGroupUpdate'
    //   })
    // },
    // 复制
    // copyGoods(id) {
    //   this.copyId = id
    //   this.goodsDialog = true;
    // },
    associationGoods(id) {
      this.associationId = id;
      this.associationGoodsDialog = true;
    },
    // 复制确认
    // copyBtn() {
    //   this.$axios
    //     .post(apis.copy_goods_group, {
    //       gid: this.copyId,
    //       tid: this.copyDataId
    //     })
    //     .then((res) => {
    //       console.log(res);
    //       if (res.data.msg === "复制成功") {
    //         this.$message({
    //           type: "success",
    //           message: "复制成功",
    //         });
    //       } else {
    //         this.$message({
    //           type: "error",
    //           message: "复制失败",
    //         });
    //       }
    //     });
    //   this.goodsDialog = false;
    //   this.copyData.name = "";
    // },
    associationBtn() {
      this.$axios
        .post(apis.link + "/" + this.associationId, {
          gid: this.associationDataId,
        })
        .then((res) => {
          if (res.data.msg === "关联成功") {
            this.$message({
              type: "success",
              message: "关联成功",
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: "关联失败",
            });
            this.getData();
          }
        });
      this.associationData.name = ""
      this.associationGoodsDialog = false;
    },
    // 关联清空
    emptyCorrelation(row) {
      this.$axios
        .get(apis.clear_link + "/" + row.id).then((res)=>{
          if (res.data.msg === "清理成功") {
            this.$message({
              type: "success",
              message: "清理成功",
            });
            this.getData()
          } else {
            this.$message({
              type: "error",
              message: "清理失败",
            });
            this.getData()
          }
        })
    },
    //打开弹出选择配置
    // setDialogSearchItem(type) {
    //   switch (type) {
    //     case "copy":
    //       this.dialogData = {
    //         searchItems: [
    //           {
    //             key: "name",
    //             label: "名称",
    //           },
    //         ],
    //         searchTableItem: [
    //           {
    //             key: "name",
    //             name: "商户名称",
    //           },
    //         ],
    //         proxyLink: "share_goods_group_list",
    //         proxyType: "get",
    //       };
    //       break;
    //   }
    //   this.dialogVisible = true;
    //   this.nowDialog = type;
    // },
    setDialogSearchItem(type) {
      switch (type) {
        case "association":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "名称",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "商品库名称",
              },
            ],
            proxyLink: "linked_list",
            proxyType: "get",
          };
          break;
      }
      this.dialogVisible = true;
      this.nowDialog = type;
    },
    //关闭简单弹出窗口（选择）
    // closeSimpleDialog(data) {
    //   console.log(data);
    //   this.dialogVisible = false;
    //   switch (this.nowDialog) {
    //     case "copy":
    //       this.copyData = data ? data : {};
    //       this.copyDataId = data.id;
    //       break;
    //   }
    // },
    closeSimpleDialog(data) {
      this.dialogVisible = false;
      switch (this.nowDialog) {
        case "association":
          this.associationData = data ? data : {};
          this.associationDataId = data.id;
          break;
      }
    },
    openView(id){
      this.$router.push({
        name: "goodsGroupUpdate",
        query: {
          id: id,
          operate: "look",
        },
      });
    },
    // 修改
    openUpdate(id) {
      this.$router.push({
        name: "goodsGroupUpdate",
        query: {
          id: id,
          operate: "update",
        },
      });
    },
    // openTrainDetail(id) {

    // },
    deleteItem(id) {
      alert.deleteAlert().then((res) => {
        this.$axios.delete(apis.goods_group_detail + "/" + id).then((res) => {
          if (res.data.code === 200) {
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },
  },
};
</script>

<style></style>
